export const CLOSED_TASK_STATUSES = [10403, 10417, 10418];
export const CLOSED_FINDING_STATUSES = [10403, 10418];
export const REVIEW_BACKLOG_STATUSES = [10414, 10415, 10416, 10419, 10421];
export const CRITICAL_HIGH_PRIORITIES = [4, 5];

export const getKpiPeriodBounds = (query: any = {}) => {
  if (query.fromDate || query.toDate) {
    const bounds: any = {};
    if (query.fromDate) {
      const from = new Date(query.fromDate);
      from.setUTCHours(0, 0, 0, 0);
      bounds.$gte = from;
    }
    if (query.toDate) {
      const to = new Date(query.toDate);
      to.setUTCHours(23, 59, 59, 999);
      bounds.$lte = to;
    }
    return bounds;
  }
  const timePeriod = Number(query.timePeriod);
  const now = new Date();
  const year = now.getUTCFullYear();
  if (timePeriod === 20601) {
    return {
      $gte: new Date(Date.UTC(year, 0, 1)),
      $lt: new Date(Date.UTC(year + 1, 0, 1)),
    };
  }
  if (timePeriod === 20602) {
    return {
      $gte: new Date(Date.UTC(year - 1, 0, 1)),
      $lt: new Date(Date.UTC(year, 0, 1)),
    };
  }
  if (timePeriod === 20603) {
    const sixMonthsAgo = new Date(now);
    sixMonthsAgo.setUTCMonth(now.getUTCMonth() - 6);
    return { $gte: sixMonthsAgo, $lte: now };
  }
  const oneYearAgo = new Date();
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  return { $gte: oneYearAgo };
};

export const parseKpiDate = (value: any) => {
  if (!value || value === 'N/A') {
    return null;
  }
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
    const [day, month, year] = value.split('-');
    const parsed = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
    return isNaN(parsed.getTime()) ? null : parsed;
  }
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : parsed;
};

export const isDateInPeriod = (value: any, query: any = {}) => {
  const date = parseKpiDate(value);
  if (!date) {
    return false;
  }
  const bounds = getKpiPeriodBounds(query);
  if (bounds.$gte && date < bounds.$gte) return false;
  if (bounds.$gt && date <= bounds.$gt) return false;
  if (bounds.$lt && date >= bounds.$lt) return false;
  if (bounds.$lte && date > bounds.$lte) return false;
  return true;
};

export const isOverdueDate = (value: any) => {
  const date = parseKpiDate(value);
  if (!date) {
    return false;
  }
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  const due = new Date(date);
  due.setUTCHours(0, 0, 0, 0);
  return due < today;
};
